import React from 'react';
import { alertError, alertSuccess } from '../config/toast';
import { allSellersReq, getBindingsReq, rmBindingReq, addBindingReq, getNearbySellersReq } from '../config/httpRoutes';
import { Row, Form, Col, Card, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSpinner, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import Loader from '../components/loader';
import SearchSelect from '../components/searchSelect';

class Bindings extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			primary_seller: '',
			secondary_seller: '',
			bindings: null,
			sellers: null,
			nearby_sellers: null,
			errors: { primary_seller: '', secondary_seller: '' },
			loading: false,
			deleteLoading: false,
			fetchLoading: true,
			form: false,
		};
	}

	componentDidMount() {
		this.getBindings();
		this.getPreReqs();
	}

	getPreReqs = async () => {
		try {
			const sellers = (await allSellersReq()).data.map( (s) => ({
				...s,
				name: `${s.name} ${s.phone}`
			}));
			this.setState({
				sellers
			});
		} catch(err) {
			alertError("Could not fetch required data");
		}
	}

	getBindings = () => {
		this.setState({fetchLoading: true});
		getBindingsReq()
		.then( (res) => {
			this.setState({bindings: res.data, form: false});
		}).catch( (err) => {
			alertError(err.response?.data?.msg || "Could not fetch bindings");
		}).finally( () => {
			this.setState({fetchLoading: false});
		});
	}

	rmBinding = (primary_seller, secondary_seller) => {
		this.setState({deleteLoading: true});
		rmBindingReq({primary_seller, secondary_seller})
		.then( (res) => {
			this.getBindings();
		}).catch( (err) => {
			alertError(err.response?.data?.msg || "Could not remove binding");
		}).finally( () => {
			this.setState({deleteLoading: false});
		});
	}
	
	handleSelect = async (name, value) => {
		if(name === 'primary_seller' && value[0]?.id) {
			const nearby_sellers = (await getNearbySellersReq({seller: value[0].id})).data.map( (s) => ({
				...s,
				name: `${s.name} ${s.phone}`
			}));
			console.log("nearby_sellers:  ",nearby_sellers);
			this.setState({nearby_sellers, [name]: value, secondary_seller: ''});
			return;
		}
		this.setState({[name]: value});
	}

	validate = () => {
		const { primary_seller, secondary_seller } = this.state;
		let errors = { primary_seller: '', secondary_seller: '' }, isValid = true;

		if(!primary_seller[0]?.id) {
			errors.primary_seller = "Select primary seller to continue";
			isValid = false;
		}
		if(!secondary_seller[0]?.id) {
			errors.secondary_seller = "Select secondary seller to continue";
			isValid = false;
		}
		
		this.setState({errors});
		return isValid;
	}

	handleSubmit = (e) => {
		e.preventDefault();
		const { primary_seller, secondary_seller } = this.state;
		if(this.validate()) {
			this.setState({loading: true});
			addBindingReq({primary_seller: primary_seller[0].id, secondary_seller: secondary_seller[0].id})
			.then( (res) => {
				this.setState({loading: false});
				alertSuccess("Binding added");
				this.getBindings();
			}).catch( (err) => {
				this.setState({loading: false});
				alertError(err?.response?.data?.msg || err?.response?.data?.message || "Could not complete request");
			});
		}
	}

	navigateAdd = () => {
		this.setState({ primary_seller: '', secondary_seller: '', errors: {primary_seller: '', secondary_seller: ''}, loading: false, form: true });
	}

	render() {
		const { primary_seller, secondary_seller, sellers, nearby_sellers, bindings, deleteLoading, errors, loading, fetchLoading, form } = this.state;
		const { handleSelect, handleSubmit, navigateAdd, rmBinding } = this;
		return (
			form ?
				<Row style={{marginLeft: 0, marginRight: 0}}>
					<Col md={{span: 4, offset: 4}} lg={{span: 4, offset: 4}} xs={12}>
						<Card style={{marginTop: '20%'}}>
							<Card.Header>
								<Card.Title style={{textAlign: 'center'}}>Add Binding</Card.Title>
							</Card.Header>
							<Card.Body>
								<Form onSubmit={handleSubmit}>
									<Form.Group>
										<SearchSelect options={sellers} onChange={handleSelect} value={primary_seller} error={errors.primary_seller} name="primary_seller" label="First Seller" />
									</Form.Group>
									<Form.Group>
										<SearchSelect options={nearby_sellers} onChange={handleSelect} value={secondary_seller} error={errors.secondary_seller} name="secondary_seller" label="Second Seller" />
									</Form.Group>

									<Button variant="success" type="submit" style={{marginLeft: '30%', width: '40%', marginTop: '25px'}} size="lg" disabled={loading}>
										{loading ?
											<FontAwesomeIcon icon={faSpinner} spin />
										:
											'Save'
										}
									</Button>
								</Form>
							</Card.Body>
						</Card>
					</Col>
				</Row>
			:
				<Row style={{marginLeft: 0, marginRight: 0, paddingLeft: '10%', paddingRight: '10%', paddingTop: '5%'}}>
					<Col md={12} style={{justifyContent: 'flex-end', display: 'flex', marginTop: '10px', marginBottom: '15px'}}>
						<Button variant="success" onClick={navigateAdd} size="md">
							<FontAwesomeIcon icon={faPlus} /> Add Binding
						</Button>
					</Col>
					{fetchLoading && <Loader />}
					{Array.isArray(bindings) ?
						bindings.length > 0 ?
							<div className="table-responsive">
								<table className="table table-hover table-attendance">
									<thead>
										<tr>
											<th>First Seller</th>
											<th>Second Sellers</th>
										</tr>
									</thead>
									<tbody>
										{bindings.map(({ p_seller, s_sellers }, i) =>
											<tr key={`bind${i}`}>
												<td>{p_seller.name} ({p_seller.phone})</td>
												{Array.isArray(s_sellers) && s_sellers.map(({ id, name, phone }, j) =>
													<td key={`scdry${j}`}>
														{name} ({phone})
														<OverlayTrigger overlay={<Tooltip>Delete</Tooltip>} delay={{ show: 150, hide: 150 }}>
															<FontAwesomeIcon icon={faTrashAlt} className="ml-2 disabled-icon font-16 cursor-pointer" onClick={(e) => { rmBinding(p_seller.id, id) }} />
														</OverlayTrigger>
													</td>
												)}
											</tr>
										)}
									</tbody>
								</table>
							</div>
						:
							<p style={{position: 'fixed', marginLeft: '34%', marginTop: '20%'}}>No bindings found.</p>
					:
						<></>
					}
				</Row>
		);
	}
}

export default Bindings;